(function() {
    'use strict';

    angular.module('stats')
        .controller('MontageStatsController', MontageStatsController);

    MontageStatsController.$inject = ['$state', 'montageStatsDataSrvc', 'dateFormatConst', 'momentSrvc', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'filterQuerySrvc'];

    function MontageStatsController($state, montageStatsDataSrvc, dateFormatConst, momentSrvc, datatableDefaultPageSizeValueConst, checkSearchSrvc, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.montageStatsRows = [];
        self.montageStatsCols = [{
            title: 'ID',
            value: 'pk',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Użytkownik',
            value: 'name',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Zamkniętych',
            value: 'closed',
            type: 'text',
            orderable: true
        }, {
            title: 'Zmontowanych',
            value: 'mounted',
            type: 'text',
            orderable: true
        }, {
            title: 'Wydruk.',
            value: 'printed',
            type: 'text',
            orderable: true
        }, {
            title: 'Wydruk. (8)',
            value: 'printed_8_plates',
            type: 'text',
            orderable: true
        }, {
            title: 'Wydruk. (4)',
            value: 'printed_4_plates',
            type: 'text',
            orderable: true
        }, {
            title: 'Wydruk. (4 + odwrotka)',
            value: 'printed_4_plates_flipped',
            type: 'text',
            orderable: true
        }, {
            title: 'Nakład wydrukowanych [szt.]',
            value: 'printed_quantity',
            type: 'text',
            orderable: true
        }, {
            title: 'Waga wydrukowanych [kg]',
            value: 'printed_weight',
            type: 'decimal',
            orderable: true
        }, {
            title: 'Naśw. płyt',
            value: 'radiated',
            type: 'text',
            orderable: true
        }, {
            title: 'Naśw. płyt (8)',
            value: 'radiated_8_plates',
            type: 'text',
            orderable: true
        }, {
            title: 'Naśw. płyt (4)',
            value: 'radiated_4_plates',
            type: 'text',
            orderable: true
        }, {
            title: 'Naśw. płyt (4 + odwrotka)',
            value: 'radiated_4_plates_flipped',
            type: 'text',
            orderable: true
        }];

        self.searchQuery = {
            pk: null,
            name: null,
            ordering: null
        };

        self.dateFormat = dateFormatConst.datePickerWithoutDay;
        self.maxDate = momentSrvc.dateToStr(momentSrvc.getCurrentDate());
        self.filterData = {
            date: self.maxDate
        };

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;
        self.changeFilter = changeFilter;

        activate();

        function activate() {
            self.filterData = filterQuerySrvc.initializeFilterData(self.filterData);
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getMontageStats();
        }

        function getMontageStats(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,

                    pk: self.searchQuery.pk,
                    name: self.searchQuery.name,
                    ordering: self.searchQuery.ordering,

                    date_year: self.filterData.date ?
                        momentSrvc.dateYear(self.filterData.date) : null,
                    date_month: self.filterData.date ?
                        momentSrvc.dateMonth(self.filterData.date) : null
                }
            }
            montageStatsDataSrvc.list(filterObj)
                .$promise
                .then(
                    function (response) {
                        self.montageStatsRows = response.results;
                        self.pageOpts.count = response.count;
                    },
                    function (response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getMontageStats);
                        }
                    }
                )
                .finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            getMontageStats();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getMontageStats();
        }

        function changeFilter() {
            filterQuerySrvc.updateFilterData(self.filterData);
            filterQuerySrvc.setLocationParams();
            getMontageStats();
        }
    }
})();
